/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_login_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft Login`)
};

const zh_hans1_login_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 登录`)
};

const zh_hant1_login_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 登入`)
};

const fr_login_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion Minecraft`)
};

const de_login_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft-Login`)
};

const ja_login_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft ログイン`)
};

const ko_login_minecraft_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minecraft 로그인`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_minecraft_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_minecraft_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_minecraft_title", locale)
	if (locale === "en") return en_login_minecraft_title(inputs)
	if (locale === "zh-Hans") return zh_hans1_login_minecraft_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_login_minecraft_title(inputs)
	if (locale === "fr") return fr_login_minecraft_title(inputs)
	if (locale === "de") return de_login_minecraft_title(inputs)
	if (locale === "ja") return ja_login_minecraft_title(inputs)
	return ko_login_minecraft_title(inputs)
};